module.exports = __webpack_public_path__ + "static/media/brush-3@1x.d9dbd9d3.png";